import AddressAppResource from './AddressAppResource';
import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessCategoryAppResource from './BusinessCategoryAppResource';
import BusinessLicenseAppResource from './BusinessLicenseAppResource';
import BusinessScheduleAppResource from './BusinessScheduleAppResource';
import BusinessTypeAppResource from './BusinessTypeAppResource';
import ContactAppResource from './ContactAppResource';
import EmailAppResource from './EmailAppResource';
import FileAppResource from './FileAppResource';
import IndustryAssociationAppResource from './IndustryAssociationAppResource';
import LanguageAppResource from './LanguageAppResource';
import MarketAppResource from './MarketAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PhoneAppResource from './PhoneAppResource';
import OrganizationMemberAppResource from './OrganizationMemberAppResource';

class BusinessProfileAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Business-Profile';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'businesses/profiles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'status',
            'name',
            'timezone',
            'isClaimed',
            'isClosed',
            'description',
            'inBusinessSince',
            'naicsCode',
            'typicalJobCostLow',
            'typicalJobCostHigh',
            'website',
            'googleMyBusiness',
            'facebook',
            'linkedin',
            'yelp',
            'homeadvisor',
            'houzz',
            'angiesList',
            'porch',
            'logoUuid',
            'primaryCategoryUuid',
            'primaryTypeUuid',
            'primaryContactUuid',
            'secondaryContactUuid',
            'organizationUuid',
            'organizationMemberUuid',
            'currentAddressUuid',
            'workAddressUuid',
            'isRecommended',
            'recommendationOrder',
            'shortDescription',
            'logo',
            'primaryCategory',
            'primaryType',
            'primaryContact',
            'secondaryContact',
            'organization',
            'marketAreas',
            'servicesProvided',
            'languagesSpoken',
            'industryAssociations',
            'hours',
            'emails',
            'phones',
            'currentAddress',
            'workAddress',
            'files',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            logo: FileAppResource,
            primaryCategory: BusinessCategoryAppResource,
            primaryType: BusinessTypeAppResource,
            primaryContact: ContactAppResource,
            secondaryContact: ContactAppResource,
            organization: OrganizationAppResource,
            organizationMember: OrganizationMemberAppResource,
            currentAddress: AddressAppResource,
            workAddress: AddressAppResource,
            marketAreas: MarketAppResource,
            servicesProvided: BusinessTypeAppResource,
            languagesSpoken: LanguageAppResource,
            industryAssociations: IndustryAssociationAppResource,
            licenses: BusinessLicenseAppResource,
            hours: BusinessScheduleAppResource,
            emails: EmailAppResource,
            phones: PhoneAppResource,
            files: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            logo: 'logo_uuid',
            primaryCategory: 'primary_category_uuid',
            primaryType: 'primary_type_uuid',
            primaryContact: 'primary_contact_uuid',
            secondaryContact: 'secondary_contact_uuid',
            organization: 'organization_uuid',
            organizationMember: 'organization_member_uuid',
            currentAddress: 'current_address_uuid',
            workAddress: 'work_address_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            status: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'active',
                    'inactive',
                ],
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            timezone: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'Central Standard Time (CST)',
                    'Eastern Standard Time (EST)',
                    'Mountain Standard Time (MST)',
                    'Pacific Standard Time (PST)',
                    'Alaskan Standard Time (AKST)',
                    'Hawaii-Aleutian Standard Time (HST)',
                ],
            },
            isClaimed: {
                type: 'boolean',
                presence: true,
            },
            isClosed: {
                type: 'boolean',
                presence: true,
            },
            description: {
                type: 'string',
            },
            inBusinessSince: {
                datetime: true,
            },
            naicsCode: {
                numericality: true,
            },
            typicalJobCostLow: {
                numericality: true,
            },
            typicalJobCostHigh: {
                numericality: true,
            },
            website: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            googleMyBusiness: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            facebook: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            linkedin: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            yelp: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            homeadvisor: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            houzz: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            angiesList: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            porch: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            logoUuid: {
                type: 'string',
            },
            primaryCategoryUuid: {
                type: 'string',
                // presence: true,
            },
            primaryTypeUuid: {
                type: 'string',
                // presence: true,
            },
            primaryContactUuid: {
                type: 'string',
                /*presence: true,*/
            },
            secondaryContactUuid: {
                type: 'string',
            },
            organizationUuid: {
                type: 'string',
            },
            organizationMemberUuid: {
                type: 'string',
                /*presence: true,*/
            },
            currentAddressUuid: {
                type: 'string',
            },
            workAddressUuid: {
                type: 'string',
            },
            languagesSpoken: {
                type: 'array'
            },
            industryAssociations: {
                type: 'array'
            },
            marketAreas: {
                type: 'array'
            },
            servicesProvided: {
                type: 'array'
            },
            isRecommended: {
                type: 'boolean',
            },
            recommendationOrder: {
                type: 'integer',
            },
            shortDescription: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 65,
                },
            },
        };
    }

}

export default BusinessProfileAppResource;
